import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';

const warrantyDocTypesKey = () => ['warranty_doc_types'];

const fetchWarrantyDocTypes = async () => {
  return await request.get(
    `/Warranty/doc_types`,
    {},
    'Не удалось получить типы гарантийных документов'
  );
};

const useWarrantyDocTypes = (options) =>
  useQuery(warrantyDocTypesKey(), fetchWarrantyDocTypes, options);

export { warrantyDocTypesKey, useWarrantyDocTypes };
